<template>
  <div id="payrollTable">
    <div class="payRollH">
        <div>
          <el-date-picker v-model="form.yearPeriod" type="month" placeholder="选择月" @change="getList" format="yyyy 年 MM 期"  value-format="yyyyMM" size="mini" style="width:165px;"></el-date-picker>
          <el-button size="mini" style="width:92px;" @click="copyTask">复制上一月</el-button>
          <el-button size="mini" style="width:92px;" @click="exportExcel">导出</el-button>
          <el-dropdown @command="importHandle">
              <el-button  size="mini" style="width:92px;margin-left:10px;font-size:14px;background:#269d7b;color:#fff;">
                导入<i class="el-icon-arrow-down el-icon--right" style="margin-left:10px;"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='import'>导入数据</el-dropdown-item>
                <el-dropdown-item command='downloadTemplate'>模板下载</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
              <el-input placeholder="搜索工号、姓名、证件号码" v-model="form.keyWord" size="mini" style="width:280px;">
                  <el-button slot="append" icon="el-icon-search"  size="mini" @click="getList" style="background: #269d7b;color: #fff;"></el-button>
              </el-input>
          </div>
          <div>
              <el-checkbox v-model="editKey" @change="showEdit">编辑</el-checkbox>
               <el-button  size="mini" style="background:#269d7b;color:#fff;" v-show="editKey" @click="saveList">
                保存
              </el-button>
          </div>
    </div>
    <public-table :table="tableData" @onHandlePaginationChange="handlePaginationChange" >
        <template v-for="(item) in tableData.config" #[item.value]="{scope}" >
            <!-- <span v-if="item.value == 'operation'" :key="item.value">
             <el-button type="text" @click="cancel(scope.row,scope)" style="color:rgb(208, 214, 222);" v-show="scope.row.isEdit">取消</el-button>
             <el-button type="text" style="color:#269d7b;" @click="editRow(scope.row,item.value)" v-show="scope.row.isEdit">保存</el-button>
             <el-button type="text" style="color:#269d7b;" @click="editTask(scope.row,item.value)" v-show="!scope.row.isEdit">编辑</el-button>
            </span> -->
            <template >
              <span v-if="scope.row" :key="item.value">
                  <div  style="width:100%;min-height:27px;" v-show="!scope.row.isEdit">{{scope.row[item.value]}}</div>
                  <el-input v-model="scope.row[item.value]" size="small" :ref="`input_${item.value}_${scope.row.id}`"  v-show="scope.row.isEdit"></el-input>
              </span>
            </template>
         </template>
        <!-- <template #summary="{scope}">
            <el-input placeholder="请输入" v-model="scope.row.summary"></el-input>
        </template> -->
    </public-table>
    <!-- 导入 -->
     <ImportExcell ref="importExcell" @refresh="getList" :yearPeriod="form.yearPeriod"/>
  </div>
</template>

<script>
import moment from 'moment'
import ImportExcell from './ImportExcell.vue'
import publicTable from "@/components/publicTable";
import {getPayRollList,savePayRoll,copyPrevMonth,findPayRollTotal} from '@/api'
export default {
  components: {
    publicTable,
    ImportExcell
  },
  computed:{
    cid(){
        return sessionStorage.getItem('cid')
    },
    token(){
         return sessionStorage.getItem('token')
    }
  },
  data() {
    return {
      editKey:false,
      totalInfo:{},
      oldRow:{},
      form: {
        yearPeriod:"",
        pageNo:1,
        pageSize:20,
        keyWord:"",
      },
      tableData: {
        border: true, // 是否带有纵向边框
        stripe: true, // 是否带有斑马纹
        loading: false, // 是否显示加载动画
        hasSelect: false, // 是否显示多选
        hasOperation: false, // 是否有操作功能
        hasContextmenu: false, // 是否有右键功能
        hasShowSummary: true, // 是否显示合计行
        getSummaries:(param)=>{
          const { columns, data } = param;
          const sums = [];
          columns.forEach((column, index) => {
            if (index === 0) {
              sums[index] = '合计';
              return;
            }
            if ([1,2,3].indexOf(index)<0) {  
              sums[index] = this.totalInfo[column.property]
            }
          });
          if (sums) {
            return sums;
          } else {
            return '';
          }
        },
        hasShowPagination: true, // 是否显示分页
        config: [
              { label: "工号", value: "workCode",   width:'120',show:'normal'},
              { label: "姓名", value: "name",   width:'120',show:'normal'},
              { label: "证件类型", value: "cardType",  width:'120',show:'normal'},
              { label: "证件号码", value: "cardNo",  width:'120',show:'normal'},
              { label: "本期收入", value: "needPay",show:'template' },
              { label: "本期免税收入", value: "taxExemptIncome", width:'150',show:'template'},
              { label: "基本养老保险费", value: "pensionInsurance", width:'150',show:'template'},
              { label: "基本医疗保险费", value: "medicalInsurance", width:'150',show:'template'},
              { label: "失业保险费", value: "unemploymentInsurance",  width:'150',show:'template'},
              { label: "住房公积金", value: "houseRent",  width:'150',show:'template'},
              { label: "累计子女教育", value: "education",width:'150',show:'template'},
              { label: "累计继续教育", value: "carry", width:'150',show:'template'},
              { label: "累计住房贷款利息", value: "houseBurden",width:'150',show:'template'},
              { label: "累计住房租金", value: "accumulatedHousingRent",  width:'150',show:'template'},
              { label: "累计赡养老人", value: "takeCareOld", width:'150',show:'template'},
              { label: "累计3岁以下婴幼儿照护", value: "babyCare", width:'200',show:'template'},
              { label: "累计个人养老金", value: "accumulatedPersonal", width:'150',show:'template'},
              { label: "企业（职业）年金", value: "enterpriseAnnuity",  width:'150',show:'template'},
              { label: "商业健康保险", value: "commercialHealth",  width:'150',show:'template'},
              //  { label:"操作",value:"operation",show:'template',fixed:'right',width:'120'}
            //   { label: "税延养老保险", value: "taxDeferredPension", width:'150',show:'template'},
            //   { label: "其他", value: "otherDeduct",show:'template'},
            //   { label: "准予扣除的捐增额", value: "approveDeductDonation", width:'150',show:'template'},
            //   { label: "减免税额", value: "taxSavings",width:'120',show:'template'},
            //   { label: "备注", value: "remarks",show:'template' },
        ],
        data: [],
        page: {
          count: 0,
          pageNo: 1,
          pageSize: 20,
        },
        center: {
          textAlign: "center",
          padding: "6px 0",
        },
      },
    };
  },
  activated(){
    let accountInfo = this.$getSessionStorage('accountInfo')
    console.log(moment(accountInfo.yearPeriodTimeStamp).format('yyyyMM'))
    this.form.yearPeriod = moment(accountInfo.yearPeriodTimeStamp).format('yyyyMM')
    this.getList()
  },
  methods: {
    async saveList(){
    const params = {
      yearPeriod:this.form.yearPeriod,
      list:this.tableData.data
    }
    const {data} = await savePayRoll(params)
      if(data.code == 1){
        this.editKey = false
        // row.isEdit = false
        this.$message.success(data.msg)
        this.getList()
      }else {
         this.editKey = false
         this.getList()
      }
  },
  showEdit(val){
    this.tableData.data = this.tableData.data.map(x=>{
      x.isEdit = val
      return x
    })
  },
  cancel(row,scope){
      Object.assign(row,this.oldRow);
      console.log(row)
  },
  defaultTime(){},
   async  copyTask(){
      const {data} = await copyPrevMonth({yearPeriod:this.form.yearPeriod})
      if(data.code == 1){
        this.$message.success(data.msg)
        this.getList()
      }
    },
    // 校验金额格式
    validateAmount(value) {
      let key = true
      // 通过正则表达式检查金额的格式
      const amountPattern = /^[0-9]+(\.[0-9]{1,2})?$/;
      if (!amountPattern.test(value)) {
        key = false
      } else {
        key = true
      }
      return key
    },
    editTask(row,property){
      this.oldRow = JSON.parse(JSON.stringify(row))
      row.isEdit = true
    },
    async editRow(row,property){
      let errors = []
      this.tableData.config.forEach(x=>{
          if(['workCode','name','cardType','cardNo','operation'].indexOf(x.value)<0){
           if(!this.validateAmount(row[x.value])){
            errors.push(`${x.label}列必须为数字`)  
              // this.$message.error(`${x.label}必须为数字`)
              // return
           }
          }
      })
      if (errors.length > 0) {
        this.$message.error(errors.join('；'))  // 使用分号连接多个错误信息
        return
      }
      let params = JSON.parse(JSON.stringify(row))
      delete params.isEdit
      params.yearPeriod = this.form.yearPeriod
      const {data} = await savePayRoll(params)
      if(data.code == 1){
        row.isEdit = false
        this.$message.success(data.msg)
        this.getList()
      }else {
        this.getList()
      }
      row.isEdit = false

    },
    exportExcel(){
        console.log(`${this.$rootUrl}salary/excel/exportV2?cid=${this.cid}&token=${this.token}&yearPeriod=${this.form.yearPeriod}`)
         window.location.href = `${this.$rootUrl}salary/excel/exportV2?cid=${this.cid}&token=${this.token}&yearPeriod=${this.form.yearPeriod}`;
        // this.$rootUrl+'voucherChief/download?cid='+cid+'&token='+token;
    },
    importHandle(command){
        if(command == 'downloadTemplate'){
            window.location.href = `${this.$rootUrl}voucherChief/download?cid=${this.cid}&token=${this.token}&templateName=工资表导入模板.xls`
        }
        if(command == 'import'){
            this.$refs.importExcell.openTask('工资表')
        }
    },
    async getList(){
      try {
        this.tableData.loading = true
        this.form.yearPeriod = this.form.yearPeriod
        const res = await findPayRollTotal(this.form)
        if(res.data.code == 1){
          this.totalInfo = res.data.data
        }
        const {data} = await getPayRollList(this.form)
        if(data.code == 1){
            this.tableData.data = data.data.list.map(x=>{
                this.$set(x,'isEdit',false)
                return x
            })
            this.tableData.page.count = Number(data.data.totalCount)
        }
        console.log(data)
      } catch (error) {
        
      }finally {
        this.tableData.loading = false
      }
    },
    handlePaginationChange(data) {
        this.form = Object.assign(this.form,data)
        this.getList()
    },
  },
};
</script>
<style lang="less" scoped>
.payRollH {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .el-input-group__append {
    border: 0 !important;
   .el-button {
    height: 28px !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/salary/components/PayrollTable.vue